import { render } from "./BaseCallout.vue?vue&type=template&id=66b69010&scoped=true"
import script from "./BaseCallout.vue?vue&type=script&lang=js"
export * from "./BaseCallout.vue?vue&type=script&lang=js"

import "./BaseCallout.vue?vue&type=style&index=0&id=66b69010&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b69010"]])

export default __exports__